import { gql, useMutation } from "@apollo/client";

export const MUTATION_ADD_ACCESS_RIGHTS = gql`
  mutation addAccessRights($repoId: ID!, $contributors: [String!]) {
    addAccessRights(input: { repoId: $repoId, contributors: $contributors }) {
      readers
      contributors
    }
  }
`;

export function useEditAccessRightsMutation() {
  const [
    editAccessRightsMutation,
    { loading: isLoadingMutation, error: errorMutation }
  ] = useMutation(MUTATION_ADD_ACCESS_RIGHTS);

  return {
    editAccessRightsMutation,
    isLoadingMutation,
    errorMutation
  };
}
